import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios, { renderDoc } from '../Axiosinstance'
import './Ad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassHalf, faSortAmountUp, faCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FaThumbsDown } from 'react-icons/fa';
import 'react-calendar/dist/Calendar.css';
import Footer from './Footer';
import Loader from '../Loader';
import { Box } from '@mui/material';
import { Button, Modal, Spinner } from 'react-bootstrap';
import Editstudent from './EditStudent';
// import axios from '../Axiosinstance';
import { removeBracketedText } from '../Axiosinstance';
import { toast, ToastContainer } from 'react-toastify';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import IconButton from '@mui/material/IconButton';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import CheckIcon from '@mui/icons-material/Check';
import { buttonBackgroundColor } from '../common'

import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Typography, Grid, TablePagination, Checkbox, FormControlLabel
} from '@mui/material';
import * as XLSX from "xlsx";
const styles = {
  button: {
    flex: 1, // Makes buttons take equal space
    minWidth: "80px", // Ensures buttons don't shrink too much
    padding: "8px 12px", // Adds better touch area
    fontSize: "14px",
    borderRadius: "5px",
    textAlign: "center",
  },

  Button: {
    whiteSpace: "nowrap",
    color: "white",// Prevents text from breaking
    padding: "10px 15px",
    fontSize: "15px",
    minWidth: "120px", // Ensures button stays visible
    textAlign: "center",
  },
};
const CustomPop = ({
  showPop,
  handleClosePop,
  handleSubmit,
  selectedStudent,
  remarks,
  handleRemarksChange,
  amount,
  handleAmountChange,
  showDiscount,
}) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ amount: '', remarks: '', amount1: '', remark: '' });
  const [showAmount1, setShowAmount1] = useState(false);
  const [showRemark, setShowRemark] = useState(false);
  const [amount1, setAmount1] = useState('');
  const [isAmount1Submitted, setIsAmount1Submitted] = useState(false);
  const [totalWantToPaid, setTotalWantToPaid] = useState(null);
  const [amountError, setAmountError] = useState('');
  const [remark, setRemark] = useState('');
  const [totalRegistrationFee, settotalRegistrationFee] = useState(0);


  useEffect(() => {
    const fetchPaymentInfo = async () => {
      if (!selectedStudent?.id || !showPop) return;

      try {
        const response = await axios.get(
          `registrationadvances/paymentDetails-info/${selectedStudent.id}`
        );
        console.log(response.data, "paymentdetails");
        settotalRegistrationFee(response.data.totalregistrationfee);
        setTotalWantToPaid(response.data.totalWanttoPaid || 0);
      } catch (error) {
        console.error('Error fetching payment info:', error);
        alert('Failed to fetch payment info. Please try again.');
      }
    };

    fetchPaymentInfo();
  }, [selectedStudent, showPop]);

  const validate = () => {
    let isValid = true;
    const newErrors = { amount: '', remarks: '', amount1: '', remark: '' };

    if (!amount && !isAmount1Submitted) {
      newErrors.amount = 'Amount is required';
      isValid = false;
    }

    if (!remarks) {
      newErrors.remarks = 'Remarks are required';
      isValid = false;
    }

    if (showAmount1 && !amount1) {
      newErrors.amount1 = 'Discount is required';
      isValid = false;
    }

    if (showRemark && !amount1) {
      newErrors.remark = 'Remark is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const validateAmount = (value) => {
    if (value <= 0) {
      setAmountError('Amount must be greater than 0');
      return false;
    }
    if (value > totalWantToPaid) {
      setAmountError(`Amount cannot exceed the total of $${totalWantToPaid}`);
      return false;
    }
    setAmountError('');
    return true;
  };

  const localHandleAmountChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    handleAmountChange(e);
    validateAmount(value);
  };

  const handleSubmitalert = async () => {
    if (validateAmount(amount)) {
      setLoading(true);
      await handleSubmit(selectedStudent);
      setLoading(false);
    }
  };

  const handleAmount1Change = (event) => {
    setAmount1(event.target.value);
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleToggleAmount1 = () => {
    setShowAmount1((prev) => !prev);
    setIsAmount1Submitted(false); // Reset after toggling
    setAmount1(''); // Clear the discount field when toggled
  };

  const handleAmount1Submit = async () => {
    if (!amount1) {
      setErrors((prev) => ({ ...prev, amount1: 'Discount is required' }));
      return;
    }

    if (amount1 > (totalRegistrationFee - 50)) {
      setErrors((prev) => ({
        ...prev,
        amount1: `Discount must be less than or equal to  ${totalRegistrationFee - 50}`,
      }));
      return;
    }

    if (!remark) {
      setErrors((prev) => ({ ...prev, remark: 'Remark is required' }));
      return;
    }
    let discountAmount = amount1
    setLoading(true);
    try {
      const response = await axios.post(
        // `registrationadvances/${selectedStudent.id}/Amount`,
        // { amount1, remark } // Include remark in the payload
        `registrationadvances/${selectedStudent.id}/discount`,
        { discountAmount, remark } // Include remark in the payload
      );
      console.log('Discount submitted successfully:', response.data);
      setIsAmount1Submitted(true); // After successful submission
    } catch (error) {
      console.error('Error submitting discount:', error);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        opacity: showPop ? 1 : 0,
        transition: 'opacity 0.3s',
        pointerEvents: showPop ? 'auto' : 'none',
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: '20px',
          borderRadius: '10px',
          width: '500px',
          maxWidth: '90%',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
          position: 'relative',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            fontSize: '24px',
            cursor: 'pointer',
          }}
          onClick={handleClosePop}
        >
          &times;
        </span>
        <h2>Payment Details</h2>

        <TextField
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          value={selectedStudent?.student?.name || ''}
          disabled
          style={{ marginBottom: '20px' }}
        />

        {/* Show Total Want to Paid field after discount is submitted or checkbox is unchecked */}
        {(!showAmount1 || isAmount1Submitted) && !showDiscount && (
          <TextField
            margin="dense"
            label="Total Want to Paid"
            type="text"
            fullWidth
            value={totalWantToPaid !== null ? `$${totalWantToPaid}` : 'Loading...'}
            disabled
          />

        )}

        <FormControlLabel
          control={
            <Checkbox
              checked={showAmount1}
              onChange={handleToggleAmount1}
              color="primary"
            />
          }
          label="Add Discount"
        />

        {showAmount1 && !isAmount1Submitted && (
          <div style={{ marginBottom: '20px' }}>
            <TextField
              margin="dense"
              label="Discount"
              type="number"
              fullWidth
              value={amount1}
              onChange={handleAmount1Change}
              error={!!errors.amount1}
              helperText={errors.amount1}
            />
            <TextField
              margin="dense"
              label="Remark"
              type="text"
              fullWidth
              value={remark}
              onChange={handleRemarkChange} // Use the separate handler for remark
              error={!!errors.remark}
              helperText={errors.remark}
            />
            <Button
              variant="contained"
              // color="secondary"
              onClick={handleAmount1Submit}
              style={{ marginTop: '10px', backgroundColor: buttonBackgroundColor }}
            >
              Apply Discount
            </Button>
          </div>
        )}

        {(!showAmount1 || isAmount1Submitted) && (
          <>
            {/* Disable Amount input if totalWantToPaid is 0 */}
            <TextField
              margin="dense"
              label="Amount"
              type="number"
              fullWidth
              value={amount}
              onChange={localHandleAmountChange}
              error={!!errors.amount || !!amountError}
              helperText={errors.amount || amountError}
              disabled={totalWantToPaid === 0} // Disable if totalWantToPaid is 0
            />
            {totalWantToPaid === 0 && (
              <p style={{ color: 'red' }}>Amount cannot be entered when total is 0.</p>
            )}
            <TextField
              margin="dense"
              label="Remarks"
              type="text"
              fullWidth
              value={remarks}
              onChange={handleRemarksChange}
              error={!!errors.remarks}
              helperText={errors.remarks}
            />
          </>
        )}

        {(!showAmount1 || isAmount1Submitted) && (
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
            <Button
              variant="contained"
              onClick={handleClosePop}
              style={{
                borderRadius: '5px',
                textTransform: 'none',
                padding: '8px 16px',
                backgroundColor: 'red',
                color: 'white',
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmitalert}
              style={{
                backgroundColor: 'green',
                color: 'white',
                borderRadius: '5px',
                padding: '10px',
              }}
            >
              Submit
            </Button>

          </div>
        )}
      </div>
    </div>
  );
};



const ConfirmationDialog = ({ open, handleClose, handleConfirm }) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{"Confirm Approval"}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Do you want to approve the payment?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Box display="flex" justifyContent="flex-end" alignItems="center" mt={2} gap={2}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="outlined"
          style={{
            backgroundColor: '#6c159d',
            color: 'white',
            borderRadius: '5px',
            textTransform: 'none',
            padding: '8px 16px',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          autoFocus
          style={{
            backgroundColor: '#6c159d',
            color: 'white',
            borderRadius: '5px',
            textTransform: 'none',
            padding: '8px 16px',
          }}
        >
          Approve
        </Button>
      </Box>
    </DialogActions>
  </Dialog>
);

const Student = () => {
  const [showPop, setShowPop] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({});
  const [paymentMode, setPaymentMode] = useState('');
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] = useState('');
  const [students, setStudents] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [studentsPerPage, setStudentsPerPage] = useState(100);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [modulenames, setModulenames] = useState([]);
  const loggedInUserId = localStorage.getItem('loggedInUserId');
  const UserType = localStorage.getItem('usertype');
  const [filter, setFilter] = useState('');

  // changes done for edit student 3.8.2024
  const closeModal = () => setIsModalOpen(false);
  // changes done for edit student 3.8.2024

  const [editStudentId, setEditStudentId] = useState(null);
  const [isEditStudentOpen, setIsEditStudentOpen] = useState(false);

  const handleEditClick = (student) => {
    setSelectedStudent(student); // Set the selected student in state
    setIsModalOpen(true); // Open the modal when edit is clicked
  };
  // changes done upto here on 3.8.2024

  // const handleChangePage = (event, newPage) => {
  //   setCurrentPage(newPage + 1);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setStudentsPerPage(parseInt(event.target.value, 10));
  //   setCurrentPage(1); // Reset to first page
  // };

  // Calculate the students to display based on the current page and rows per page
  // const displayedStudents = students.slice(
  //   (currentPage - 1) * studentsPerPage,
  //   currentPage * studentsPerPage
  // );
  const [scheduleData, setScheduleData] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({
    workPermitSpass: null,
    workPermitOne: null,
    repass: null,
    dependentPass: null,
    passport: null,
    markSheet: null,
    certificate: null,
    profilePicture: null,
  });
  const [open, setOpen] = useState(false);
  const [documentType, setDocumentType] = useState('');

  // Fetch students function
  const fetchStudents = async () => {
    let response;
    try {
      if (UserType == 4) {
        // response = await axios.get(`registrationadvances/unapprovedPaymentTypes/register?approveReference=${loggedInUserId}`);
        response = await axios.get(
          `registrationadvances/new-approved-students`
        );
      }
      else {
        response = await axios.get('registrationadvances/unapprovedPaymentTypes/register', {
          params: {
            approveReference: loggedInUserId
          }
        });
      }
      setStudents(response.data); // Assuming the response data is an array of student objects
      setLoading(false);
      console.log()
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  // Use effect to fetch students on component mount
  useEffect(() => {
    fetchStudents();
  }, []);

  // Handle opening the payment popup
  const handleClickOpen = (student) => {
    setSelectedStudent(student);
    setShowPop(true);
  };


  const handleDeleteClick = (student) => {
    setSelectedStudent(student);
    setOpenDeleteDialog(true);
  };



  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
    setSelectedStudent(null);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.post(`/registrationadvances/${selectedStudent.id}/reject`);
      console.log('Student rejected:', response.data);
      toast.success('Student  Rejected successfully', {
        autoClose: 3000, // 3 seconds
      });

      setOpenDeleteDialog(false);
      fetchStudents(); // Refresh data after deletion
    } catch (error) {
      console.error('Error rejected student:', error);
      toast.error('Error rejected student');
      setOpenDeleteDialog(false);
    }
  };


  // Handle closing the payment popup
  const handleClosePop = () => {
    setShowPop(false);
    setSelectedStudent({});
    setPaymentMode('');
    setRemarks('');
    setAmount('');
    setLoading(false);
  };

  const handlePaymentModeChange = (event) => {
    setPaymentMode(event.target.value);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleSubmit = () => {
    // Save payment details to state, but do not submit yet
    const paymentDetails = {
      sessionId: selectedStudent.id,
      sessionDate: new Date().toISOString().split('T')[0],
      amount: amount,
      paymentMode: 'offline',
      remarks: remarks
    };
    setSelectedStudent({ ...selectedStudent, paymentDetails });
    setShowPop(true); // Show the modal with payment details
    setConfirmOpen(true);
  };

  // const handleApprove = async () => {
  //   setLoading(true);
  //   const { sessionId, sessionDate, amount, paymentMode, remarks } = selectedStudent.paymentDetails;
  //   const paymentDetails = {
  //     sessionId: selectedStudent.id,
  //     sessionDate,
  //     amount,
  //     paymentMode: 'offline',
  //     remarks
  //   };

  //   try {
  //     const paymentResponse = await axios.post(`registrationadvances/${sessionId}/course-fee-details`, paymentDetails);
  //     console.log('Payment details added successfully:', paymentResponse.data);

  //     const approveResponse = await axios.post(`/registrationadvances/${sessionId}/approve`);
  //     console.log('Approved successfully:', approveResponse.data);

  //     // const activateResponse = await axios.put(`student/${sessionId}/activate`);
  //     // console.log('Student activated successfully:', activateResponse.data);

  //     // await axios.put(`/home/${sessionId}/activate?registrationAdvanceId=${selectedStudent.id}`);

  //     const paymentStatusResponse = await axios.put(`registrationadvances/status/${sessionId}`, { paymentStatus: 'paid' });
  //     console.log('Payment status updated to "Paid" successfully:', paymentStatusResponse.data);

  //     const setStatusResponse = await axios.post(`registrationadvances/${sessionId}/course-fee-details/set-status`, { status: 'Paid' });
  //     console.log('Payment status updated to "Paid" successfully:', setStatusResponse.data);

  //     const infoResponse = await axios.get(`/registrationadvances/info/${sessionId}`);
  //     const studentInfo = infoResponse.data;
  //     console.log('Fetched student information:', studentInfo);

  //     // Perform the additional API calls using Promise.all
  //     await Promise.all([
  //       axios.post(`/registrationadvances/send-receipt/${sessionId}`),
  //       axios.post(`/registrationadvances/send-receipts/${sessionId}`)
  //     ]);

  //     console.log('Receipts sent successfully');

  //     handleClosePop();
  //     fetchStudents(); // Refresh student data after updating status
  //   } catch (error) {
  //     console.error('There was an error processing the approval workflow!', error);

  //     if (error.response) {
  //       // The request was made and the server responded with a status code that falls out of the range of 2xx
  //       console.error('Error data:', error.response.data);
  //       console.error('Error status:', error.response.status);
  //       console.error('Error headers:', error.response.headers);
  //     } else if (error.request) {
  //       // The request was made but no response was received
  //       console.error('Error request:', error.request);
  //     } else {
  //       // Something happened in setting up the request that triggered an Error
  //       console.error('Error message:', error.message);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleApprove = async () => {
    setLoading(true);
    const { sessionId, sessionDate, amount, paymentMode, remarks } = selectedStudent.paymentDetails;
    const paymentDetails = {
      sessionId: selectedStudent.id,
      sessionDate,
      amount,
      paymentMode: 'offline',
      remarks
    };

    try {

      const paymentAmountResponse = await axios.post(`registrationadvances/${sessionId}/PaymentAmount`, { paymentAmount: amount });
      // console.log('Fetched Payment Amount successfully:', paymentAmountResponse.data);


      const paymentResponse = await axios.post(`registrationadvances/${sessionId}/course-fee-details`, paymentDetails);
      console.log('Payment details added successfully:', paymentResponse.data);

      const approveResponse = await axios.post(`/registrationadvances/${sessionId}/approve`);
      console.log('Approved successfully:', approveResponse.data);

      // const activateResponse = await axios.put(`student/${sessionId}/activate`);
      // console.log('Student activated successfully:', activateResponse.data);

      // await axios.put(`/home/${sessionId}/activate?registrationAdvanceId=${selectedStudent.id}`);

      // const paymentStatusResponse = await axios.put(`registrationadvances/status/${sessionId}`, { paymentStatus: 'paid' });
      // console.log('Payment status updated to "Paid" successfully:', paymentStatusResponse.data);

      // const setStatusResponse = await axios.post(`registrationadvances/${sessionId}/course-fee-details/set-status`, { status: 'Paid' });
      // console.log('Payment status updated to "Paid" successfully:', setStatusResponse.data);

      const infoResponse = await axios.get(`/registrationadvances/info/${sessionId}`);
      const studentInfo = infoResponse.data;
      console.log('Fetched student information:', studentInfo);

      const invoiceResponse = await axios.get(`/registrationadvances/detailsForSendInvoice/${sessionId}`);
      console.log('Fetched invoiceResponse:', invoiceResponse);


      // Perform the additional API calls using Promise.all
      await Promise.all([
        axios.post(`/registrationadvances/send-receipt/${sessionId}`),
        axios.post(`/registrationadvances/send-receipts/${sessionId}`)
      ]);

      console.log('Receipts sent successfully');

      handleClosePop();
      fetchStudents(); // Refresh student data after updating status
    } catch (error) {
      console.error('There was an error processing the approval workflow!', error);

      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        console.error('Error data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error request:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error message:', error.message);
      }
    } finally {
      setLoading(false);
    }
  };



  const handleOpenConfirm = () => {
    setConfirmOpen(true);
  };

  const handleCloseConfirm = () => {
    setConfirmOpen(false);
  };

  const handleConfirmApprove = () => {
    handleApprove();
    setConfirmOpen(false);
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value.toLowerCase()); // Convert filter value to lowercase for case-insensitive filtering
  };
  const filteredStudents = students.filter((student) => {
    return (
      student.student.name.toLowerCase().includes(filter) ||
      student.student.nric.toLowerCase().includes(filter)
    );
  });

  const handleViewClick = async (student) => {
    setLoading(true);
    try {
      const response = await axios.get(`/registrationadvances/${student.id}`);
      const { scheduleDate, markSheet, certificate, batch, ...studentData } = response.data;

      // Copy batch details to studentData
      const updatedStudentData = { ...studentData, batch };

      // Create a map for moduleDetails based on id
      const moduleDetailsMap = {};
      batch?.moduleDetails.forEach(module => {
        moduleDetailsMap[module.id] = module.moduleName;
      });

      // Map the module details to the schedule data based on startModulus
      const updatedScheduleData = scheduleDate.map(schedule => {
        const moduleDetail = batch?.moduleDetails.find(
          module => module.id === schedule.startModulus
        );
        return {
          ...schedule,
          moduleDetail: moduleDetail ? moduleDetail.moduleName : 'N/A'
        };
      });

      // Update student details and schedule data
      setStudentDetails({ ...updatedStudentData, markSheet, certificate });
      setScheduleData(updatedScheduleData);

      // Log for debugging purposes
      console.log("Student Data:", updatedStudentData);
      console.log("Updated Schedule Data:", updatedScheduleData);
      console.log("Response Data:", response.data);

      // Set uploaded files including markSheet
      setUploadedFiles({
        workPermitSpass: studentData.workPermitSpass,

        passport: studentData.passport,
        markSheet: markSheet, // Set markSheet
        certificate: certificate,
        profilePicture: studentData.profilePicture,
      });

      setOpenViewDialog(true);
    } catch (error) {
      console.error('Error fetching student details:', error);
      toast.error('Error fetching student details');
    } finally {
      setLoading(false);
    }
  };


  const handleCloseViewDialog = () => {
    setOpenViewDialog(false);
    setStudentDetails(null);
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  function formatDateEnd(dateString) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }

  const handleOpenModal = (docType) => {
    setDocumentType(docType);
    setOpen(true);
  };

  // Render loading component if still loading
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '20px',
        color: '#555',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f0f0f0'
      }}>
        Please wait...
      </div>
    );
  }



  const markSheets = studentDetails?.markSheet;
  const certificate = studentDetails?.certificate;
  const institutionDetails = studentDetails?.institutionDetails || [];

  // Filter out any keys that contain "Progress" or "Status"
  const filteredMarkSheets = markSheets
    ? Object.entries(markSheets).filter(([key]) => !key.includes('Progress') && !key.includes('Status'))
    : [];
  const filteredCertificate = certificate
    ? Object.entries(certificate).filter(([key]) => !key.includes('Progress') && !key.includes('Status'))
    : [];

  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const maskNRIC_FIN = (value) => {
    if (!value) return "";
    let masked = value.slice(0, -4).replace(/\w/g, "*"); // Replace all but last 4 characters with '*'
    return masked + value.slice(-4); // Append the last 4 characters
  };


  return (
    // <div>
    //   {
    //     loading ? (
    //       <div>
    //         <Loader />
    //       </div >
    //     ) : (
    //       <div className="container-fluid" style={{ maxWidth: '1200px' }}>
    //         <h2 className="heading" align="center" style={{ color: '#FFFFFF', fontSize: '28px', marginTop: '35px' }}>
    //           Offline Payments
    //         </h2>
    //         <Paper>
    //           <TableContainer>
    //             <Table>
    //               <TableHead>
    //                 <TableRow>
    //                   <TableCell>S.no</TableCell>
    //                   <TableCell>Name</TableCell>
    //                   <TableCell>NRIC No</TableCell>
    //                   <TableCell>Course</TableCell>
    //                   <TableCell>Registration Date</TableCell>
    //                   <TableCell>Action</TableCell>
    //                   <TableCell>View</TableCell>
    //                 </TableRow>
    //               </TableHead>
    //               <TableBody>
    //                 {displayedStudents.length > 0 ? (
    //                   displayedStudents.map((student, index) => (

    //                     <TableRow key={student.id}>
    //                       <TableCell>{index + 1}</TableCell>
    //                       <TableCell>{student.student.name}</TableCell>
    //                       <TableCell>{student.student.nric}</TableCell>
    //                       <TableCell>{removeBracketedText(student.batch.course)}</TableCell>
    //                       <TableCell>{student.date}</TableCell>
    <div>
      <Modal show={isModalOpen} onHide={closeModal} dialogClassName="modal-fullscreen">
        <Modal.Header closeButton>
          <Modal.Title>Edit Student</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Editstudent from={false} onAction={fetchStudents} studentId={selectedStudent ? selectedStudent.id : null} /> {/* Pass the selectedStudent.id as studentId prop */}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="contained"
            style={{
              backgroundColor: "#007bff",
              color: "white",
            }} onClick={closeModal}>Close</Button>
        </Modal.Footer>
      </Modal>
      {loading ? (

        <div>please wait.......</div>) : (
        <div className="container-fluid" style={{ maxWidth: '1200px' }}>
          <h2 className="heading" align="center" style={{ color: '#FFFFFF', fontSize: '28px', marginTop: '35px' }}>
            Offline Payments
          </h2>
          <Paper>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>


              <TextField
                type="text"
                placeholder="Search by Name or NRIC"
                value={filter}
                onChange={handleFilterChange}
                style={{
                  padding: '8px', fontSize: '16px', flex: 1,  // Makes the input take the remaining space
                  boxSizing: "border-box",
                }}
              />
              <Button
                variant="contained"
                style={{
                  backgroundColor: buttonBackgroundColor,
                  color: "white",
                  minWidth: "150px", // Ensure the button has a minimum width
                  padding: '8px',
                  height: "52px", // Prevent button from shrinking
                }}
                onClick={() =>
                  exportToExcel(
                    students.map((student, index) => ({
                      "S.NO": index + 1,
                      Name: student.student.name.toUpperCase(),
                      "NRIC No": student.student.nric,
                      Course: removeBracketedText(student.batch.course),
                      "Registration Date": student.enrolledDate,
                    })),
                    "Students_Data"
                  )
                }
              >
                Download Excel
              </Button>
            </div>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>S.no</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Name</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>NRIC No</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Course</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Date</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>View</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredStudents.length > 0 ? (
                    filteredStudents.map((student, index) => (
                      <TableRow key={student.id}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">{student.student.name.toUpperCase()}</TableCell>
                        {/* <TableCell>{student.student.nric}</TableCell> */}
                        <TableCell align="center">{(student.student.nric)}</TableCell>
                        <TableCell align="center">{removeBracketedText(student.batch.course)}</TableCell>
                        <TableCell align="center">{student.enrolledDate}</TableCell>

                        <TableCell align="center">
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton
                              variant="primary"
                              onClick={() => handleClickOpen(student)}
                              style={{ backgroundColor: '#28a745', color: '#fff' }}
                            >
                              <CheckIcon />
                            </IconButton>
                            <div style={{ width: '1px', height: '24px', backgroundColor: '#ccc', margin: '0 10px' }}></div>
                            <IconButton
                              variant="danger"
                              onClick={() => handleDeleteClick(student)}
                              style={{ backgroundColor: '#dc3545', color: '#fff' }}
                            >
                              <ThumbDownIcon />
                            </IconButton>
                          </div>

                        </TableCell>
                        {/* <TableCell>
                            <Button
                              onClick={() => handleViewClick(student)}
                              style={{
                                backgroundColor: '#2F58A0',
                                color: '#fff',
                                borderRadius: '10%',
                                padding: '10px 15px',
                                marginLeft: '10px',
                              }}
                            >
                              View
                            </Button>
                          </TableCell> */}

                        <TableCell align="center" >
                          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            <Button
                              onClick={() => handleViewClick(student)}
                              variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }}
                            >
                              View
                            </Button>
                            <Button
                              onClick={() => handleEditClick(student)}
                              variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }}
                            >
                              Edit
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6}>No students found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              {/* <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={students.length}
                rowsPerPage={studentsPerPage}
                page={currentPage - 1}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to }) => `${from}-${to} of ${students.length}`}
              /> */}
            </TableContainer>
          </Paper>

          <Dialog fullScreen open={openViewDialog} onClose={handleCloseViewDialog}>
            <DialogTitle>
              <div >
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', textAlign: 'center' }}>{studentDetails?.student.fullname || '-'}</Typography>
              </div>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={4}>

                {/* <Grid container spacing={3}> */}

                <Paper elevation={3} style={{ padding: '24px', backgroundColor: '#f5f5f5', borderRadius: '8px', maxWidth: '1400px', margin: '62px auto' }}>
                  <Typography variant="h6" gutterBottom style={{ marginBottom: '16px', color: '#333', borderBottom: '2px solid #ccc', paddingBottom: '8px', fontWeight: 'bolder' }}>Basic Personal Information</Typography>
                  {studentDetails ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Name:</strong> {studentDetails.name || '-'}</Typography>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body1"><strong>Surname:</strong> {studentDetails.sureName || '-'}</Typography>
                  </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Phone No:</strong> {studentDetails.handPhone || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Date of Birth:</strong> {studentDetails.dob || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Gender:</strong> {studentDetails.gender || '-'}</Typography>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Nationality:</strong> {studentDetails.countryBirth || '-'}</Typography>
                    </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Passport No:</strong> {studentDetails.passportNo || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Email:</strong> {studentDetails.email || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Type:</strong> {studentDetails?.type || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Course:</strong> {removeBracketedText(studentDetails?.batch.course) || '-'}</Typography>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Intake:</strong> {studentDetails?.intake || '-'}</Typography>
                    </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Country of Birth:</strong> {studentDetails?.countryBirth || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Nationality:</strong> {studentDetails?.nationality || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1">
                          <strong>Know About Program:</strong> {studentDetails?.knowAboutProgram || '-'}
                          {(studentDetails?.knowAboutProgram === 'referral' || studentDetails?.knowAboutProgram === 'other') && (
                            <>
                              {' - '}
                              {studentDetails?.knowAboutProgram === 'referral'
                                ? studentDetails?.referalfriend || '-'
                                : studentDetails?.otherDetails || '-'}
                            </>
                          )}
                        </Typography>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body1"><strong>Application Signature:</strong> {studentDetails?.applicationSignature || '-'}</Typography>
                  </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Date:</strong> {formatDate(studentDetails?.enrolledDate) || '-'}</Typography>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1">
                          <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Office): </strong>{studentDetails?.phoneOffice || '-'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1">
                          <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Home): </strong>{studentDetails?.phoneHome || '-'}
                        </Typography>
                      </Grid>
                      {/* <Typography variant="h6" gutterBottom style={{ marginBottom: '16px', color: '#333', borderBottom: '2px solid #ccc', paddingBottom: '8px', fontWeight: 'bolder' }}>Additional Information</Typography> */}

                      {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body1"><strong>Non-Singaporean:</strong> {studentDetails?.nonSingaporean || '-'}</Typography>
                  </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>Company:</strong> {studentDetails?.company || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="body1"><strong>{studentDetails?.proofType === 'NRIC' ? 'NRIC :' : 'FIN :'}</strong> {studentDetails.student?.nric || '-'}</Typography>
                      </Grid>
                      <br />
                      <Grid item xs={12} sm={6}>
                        <Typography ><FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Office):</strong> {studentDetails?.addressOffice || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography ><FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Home):</strong> {studentDetails?.addressHome || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography><strong>Contact Name:</strong> {studentDetails?.emergencyName || '-'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography ><strong><FontAwesomeIcon icon={faPhone} /> Emergency Contact:</strong> {studentDetails?.emergencyPhone || '-'}</Typography>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Typography ><strong>Relation:</strong> {studentDetails?.emergencyRelation || '-'}</Typography>
                      </Grid>

                    </Grid>
                  ) : (
                    <Typography style={{ marginTop: '16px', color: 'red', textAlign: 'center' }}>No information available.</Typography>
                  )}
                </Paper>
                <>
                  <Table style={{ maxWidth: "100%", marginLeft: "50px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Document Name</TableCell>
                        <TableCell>View</TableCell>
                        {/* <TableCell>Verify</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {studentDetails && studentDetails.workPermitSpass && (
                        <TableRow key="workPermitSpass">
                          <TableCell>NRIC/WorkPermit/S-Pass-Front</TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }} onClick={() => renderDoc(studentDetails.workPermitSpass, '_blank')}>
                              View
                            </Button>
                          </TableCell>
                          {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('workPermitSpass')}>Verify</Button>
                        </TableCell> */}
                        </TableRow>
                      )}
                      {studentDetails && studentDetails.workPermitOne && (
                        <TableRow key="workPermitOne">
                          <TableCell>NRIC/WorkPermit/S-Pass-Back</TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }} onClick={() => renderDoc(studentDetails.workPermitOne, '_blank')}>
                              View
                            </Button>
                          </TableCell>
                          {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('workPermitSpass')}>Verify</Button>
                        </TableCell> */}
                        </TableRow>
                      )}

                      {studentDetails && studentDetails.passport && (
                        <TableRow key="passport">
                          <TableCell>Passport</TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }} onClick={() => renderDoc(studentDetails.passport, '_blank')}>
                              View
                            </Button>
                          </TableCell>
                          {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('passport')}>Verify</Button>
                        </TableCell> */}
                        </TableRow>
                      )}
                      {filteredMarkSheets.map(([level, url], index) => (
                        <TableRow key={level}>
                          <TableCell>marksheet for {institutionDetails[index]?.institution || 'Unknown Institution'}</TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }} onClick={() => renderDoc(url, '_blank')}>
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}


                      {/* doubt */}
                      {/* {filteredMarkSheets.map(([level, url], index) => (
                    <TableRow key={level}>
                      <TableCell>{institutionDetails[index]?.certificate || 'Unknown Institution'}</TableCell>
                      <TableCell>
                        <Button onClick={() => window.open(url, '_blank')}>
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))} */}

                      {(!markSheets || filteredMarkSheets.length === 0) && (
                        <TableRow>
                          <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                            <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No marksheets available
                          </TableCell>
                        </TableRow>
                      )}
                      {filteredCertificate.map(([level, url], index) => (
                        <TableRow key={level}>
                          <TableCell>certificate for {institutionDetails[index]?.institution || 'Unknown Institution'}</TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'
                              }} onClick={() => renderDoc(url, '_blank')}>
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                      {(!certificate || filteredCertificate.length === 0) && (
                        <TableRow>
                          <TableCell colSpan={2} style={{ textAlign: 'center', height: '40px' }}>
                            <i className="fa fa-exclamation-circle" style={{ marginLeft: '5px' }} /> No certificate available
                          </TableCell>
                        </TableRow>
                      )}


                      {studentDetails && studentDetails.profilePicture && (
                        <TableRow key="profilePicture">
                          <TableCell>Profile Picture</TableCell>
                          <TableCell>
                            <Button variant="contained"
                              style={{
                                backgroundColor: buttonBackgroundColor,
                                color: "white",
                                minWidth: '90px'


                              }}
                              onClick={() => renderDoc(studentDetails.profilePicture, '_blank')}>
                              View
                            </Button>
                          </TableCell>
                          {/* <TableCell>
                          <Button onClick={() => handleVerifyFile('profilePicture')}>Verify</Button>
                        </TableCell> */}
                        </TableRow>
                      )}

                    </TableBody>
                  </Table>


                  <ToastContainer />
                </>
                {/* </Grid> */}
                <Grid item xs={6}  >
                  <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                    <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }} >Institution Details</Typography>
                    {studentDetails?.institutionDetails && studentDetails?.institutionDetails.length > 0 ? (
                      <TableContainer>
                        <Table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                          <TableHead>
                            <TableRow >
                              <TableCell style={{ fontWeight: 'bold' }}>Institution</TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>Year</TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>Full Time/Part Time</TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>Qualifications Achieved</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {studentDetails.institutionDetails.map((detail, index) => (
                              <TableRow key={index}>
                                <TableCell>{detail.institution}</TableCell>
                                <TableCell>{detail.year}</TableCell>
                                <TableCell>{detail.fullTimeOrPartTime}</TableCell>
                                <TableCell>{detail.qualificationsAchieved}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Typography>No institution details available</Typography>
                    )}
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                    <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Course Schedule </Typography>
                    <TableContainer>
                      <Table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                          <TableRow>
                            <TableCell style={{ fontWeight: 'bold', borderBottom: '2px solid #ccc' }}>Start Module</TableCell>
                            <TableCell style={{ fontWeight: 'bold', borderBottom: '2px solid #ccc' }}>Start Date</TableCell>
                            <TableCell style={{ fontWeight: 'bold', borderBottom: '2px solid #ccc' }}>End Date</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {scheduleData.map((schedule, index) => (
                            <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
                              <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>{schedule.moduleDetail}</TableCell>
                              <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>{formatDateEnd(schedule.startDate)}</TableCell>
                              <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>{formatDateEnd(schedule.endDate)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Grid>

              </Grid>
            </DialogContent>
            <DialogActions>
              <button variant="contained"
                style={{
                  backgroundColor: buttonBackgroundColor,
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                }}
                


                onClick={handleCloseViewDialog}   >
                Close
              </button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openDeleteDialog}
            onClose={handleCancelDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure to delete this student?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancelDelete} color="primary">
                No
              </Button>
              <Button onClick={handleDelete} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {showPop && (
            <CustomPop
              showPop={showPop}
              handleClosePop={handleClosePop}
              handleSubmit={handleSubmit}
              selectedStudent={selectedStudent}
              paymentMode={paymentMode}
              handlePaymentModeChange={handlePaymentModeChange}
              remarks={remarks}
              handleRemarksChange={handleRemarksChange}
              amount={amount}
              handleAmountChange={handleAmountChange}
              handleOpenConfirm={handleOpenConfirm}
            />
          )}

          <ConfirmationDialog
            open={confirmOpen}
            handleClose={handleCloseConfirm}
            handleConfirm={handleConfirmApprove}
          />
        </div>
      )
      }
    </div>
  );
};

export default Student;